// import { StreamVideoClient,StreamVideo,StreamCall, LivestreamLayout} from "@stream-io/video-react-sdk";
import { useCallback, useEffect, useReducer,useState } from 'react';
import Comments from '../components/Comments';
import CommentInput from '../components/CommentInput';
import { HbrCancel,HbrFlagReport, HbrLiveCam} from "./Mycustomsvgicons";
import { get, ref, set } from 'firebase/database';
import { realTimeDB } from '../firebase';
import { Link, useLocation } from 'react-router-dom';
import { actionConsts, reducer } from './StateManager';
import { CustomAlertDialog } from './CustomAlertDialog';
import { format } from 'date-fns';
import LiveCommentCount from './LiveCommentsCount';
import ViewWebWebRTC, { TextShortenerConfig } from './GeneralClasses';
import ShareComponent from './ShareComponent';
import UseLayout from './useLayout';


const ViewLiveStream =() => {
    const [showChat,setShowChat]=useState(true);
    const [liveStarted,setLiveStarted]=useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "No Live stream in session.\nPrograms available to Broadcast: Sunday Bible studies 3:30pm\nAll other Horemow conferences and programs of the movement", showAlert: false});
    const [linkFromDB,setLinkFroMdb]=useState("");
   const [docIDstofetch,setDocIDquery]=useState("");
   const [livetoken,setLivetoken]=useState("");
   const [apikey,setApikey]=useState("");
   const {width} = UseLayout();
   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);    
   const watch = queryParams.get("watch");



    const handleCloseAlert=()=>{
        dispatch({type: actionConsts.SHOWALERT, payload: true});
      };


      const handleMakeCommentsVisible=useCallback((data)=>{
        if (data === true) {
            setShowChat(true);
            setDocIDquery("");
        }
      },[]);

      const handleHideComments=useCallback(()=>{
        setShowChat(false);
        sessionStorage.setItem("docID",format(new Date(),"yyyyMMddHHmmss"));
        setDocIDquery(sessionStorage.getItem("docID"));
      },[]);

    useEffect(()=>{
        async function fetchUrl() {
            const viewDate = format(new Date(), "yyyy-MM-dd");
            const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
            const randomUUid = `hbrUser${Math.floor(Math.random() * 10000)}${alphabets.charAt(Math.floor(Math.random() * alphabets.length))}`
          
            const livebooleanvalue = await get(ref(realTimeDB,"Banner/hbrLiveSettings/live"));
               setLiveStarted(livebooleanvalue.val());
               sessionStorage.setItem("docID",format(new Date(),"yyyyMMddHHmmss"));
               setDocIDquery(sessionStorage.getItem("docID"));
               const livetokensnapshot = await get(ref(realTimeDB,"Banner/liveToken"));
                setLivetoken(livetokensnapshot.val());
                const apikeySnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/apiKey"));
                setApikey(apikeySnapshot.val());
                const linkTocopySnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/shareLink/link"));
                setLinkFroMdb(linkTocopySnapshot.val());
                const viewerID = localStorage.getItem("bloggerid");
                const viewerName = localStorage.getItem("userName");
                set(ref(realTimeDB,`Views${viewDate}/${viewerID ? viewerID : randomUUid}`),viewerName ? viewerName: randomUUid);
            
        };
        fetchUrl();
    },[]);

    // const scrollText=useCallback(()=>{
    //     if (liveStarted) {
    //         const intervalId = setInterval(() => {
    //             if(scrollRef.current){
    //               if(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft <= scrollRef.current.clientWidth){
    //                 setMarqueeText(watch);
    //                 // setMarqueeText((prevText) => {
    //                 //     const updatedText = [...prevText, watch];
    //                 //     return updatedText.slice(-3); // Trim to maxItems length
    //                 // });
    //                 scrollRef.current.scrollLeft = 0;
    //               }else{
    //                 scrollRef.current.scrollLeft += 1;
    //               }
                
    //             }
    //           }, 50);
    
    //           return()=>{
    //             clearInterval(intervalId);
    //             }
    //     }

    // },[liveStarted,watch]);

    // useEffect(()=>{
    //     scrollText();
     
    // },[scrollText]);

 


    return (  
 
    <div className='livestreamviewlayout'>
             {!liveStarted && !state.showAlert &&
                  <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert}/>
            }

        <div className="livestreamviewcontent" style={{width:"100%",height:"100vh"}}>

            <div className={`livevideoplayer ${showChat ? 'resize':'full'}`} style={{backgroundColor:"black",position:"relative"}}>

            {liveStarted && 
                    <div style={{display:"flex",gap:"5px",height:"auto",caretColor:"transparent"}}>
                        <div className='flex-row2'
                         style={{
                             padding:"4px",
                             gap:"3px",
                             width:"fit-content",
                             border:"none",
                             backgroundColor:"red",
                             color:"white",
                             fontWeight:"bold",
                             fontSize:"0.8em",
                             borderRadius:"10px",
                             animation:"fade180 2s linear infinite"}}>
                             <h4 style={{color:"white"}}>Live </h4>
                             <HbrLiveCam width="1em" height="1em" fillColour="#FFFFFF"/>
                         </div>

                         <div style={{padding:"5px"}}>
                            {/* <pre style={{color:"white",fontWeight:"bold"}}>{`${watch} ${marqueeText}`}</pre> */}
                            {width <= 600 ? <TextShortenerConfig fullText={watch} words={5} /> : <TextShortenerConfig fullText={watch} words={10} />}
                            
                        </div>

                    </div>
                
                }

                {liveStarted && <ViewWebWebRTC token={livetoken} apiKey={apikey} showchat={showChat}/>} 
                
                {!showChat && 
                    <LiveCommentCount showChat={showChat} docIDstofetch={docIDstofetch} handleShowComment={handleMakeCommentsVisible} />
                }
                
            </div>

           

            <div className={`livestreamcommentdiv flex-column1 ${showChat ? 'show':'hide'}`}>
                    <div className="livestreamcommentstop flex-spacebetween" style={{width:"100%",backgroundColor:"white"}}>

                        {/* <div style={{position:"relative"}}>
                        <button style={{border:'none',fontWeight:"bold",backgroundColor:"#efefef",cursor:"pointer"}}
                                onClick={()=>setShare(prev => !prev)}>
                            Share <HbrShareIcon width="1.6em" height="1.6em" fillColour="black"/>
                        </button>

                        {isshare &&
                            <div className='flex-spacebetween' style={{
                                position:"absolute",
                                width:"220px",
                                padding:"10px",
                                top:"100%",
                                left:"0px",
                                zIndex:"1",
                                paddingRight:"1em",
                                boxSizing:"border-box",
                                backgroundColor:"white",
                                boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23",
                                borderRadius:"10px"}}>
                                    <div className='flex-row2' style={{width:"70%",overflow:"hidden"}}>
                                    <pre>{`${linkFromDB}hbrlive?watch=${watch}`}</pre>
                                    </div>
                               
                                <button style={{
                                    backgroundColor:"transparent",
                                    cursor:"pointer",
                                    border:"none"
                                }} onClick={()=>handleCopyLink(`${linkFromDB}hbrlive?watch=${watch}`)}>
                                    Copy <CopyAll/>
                                </button>
                            </div>
                        }
                        </div> */}

                        <ShareComponent linkFromDB={linkFromDB} watch={watch}/>
                      
                        <Link to={"/contact"} style={{textDecoration:"none",color:"red",backgroundColor:"whitesmoke"}}>
                             report <HbrFlagReport width="1.6em" height="1.6em" fillColour="black"/>
                        </Link>
                          
                        <HbrCancel width="1.7em" height="1.7em" fillColour="#000000" handleClick={handleHideComments}/>
                        
                    </div>
                    <Comments/>
                    <CommentInput/>
            </div>
        </div>

    </div>
    
    );
}
export default ViewLiveStream;